export default function configureTagManager(hostname) {
  switch (hostname) {
    default:
      return 'GTM-ABC23';
  }
}

export function getGoogleAdsId() {
  if (
    typeof window === 'undefined' ||
    !window ||
    !window.__ANALYTICS_CONFIG_DATA__
  ) {
    return null;
  }

  const lang =
    window &&
    window.__REDUX_STATE__ &&
    window.__REDUX_STATE__.general &&
    window.__REDUX_STATE__.general.lang
      ? window.__REDUX_STATE__.general.lang
      : '-';

  const key = `Google_conversionId-${lang}-0`;

  return window.__ANALYTICS_CONFIG_DATA__[key] || null;
}
